import React from 'react';
import { useController, UseControllerProps, useFormContext } from 'react-hook-form';
import styles from '@common/inputFields/inputFields.module.scss';
import { PATTERN } from '@utils/validators/pattern';
import useRecommendEmailList from '@utils/hooks/useRecommendEmailList';
import classnames from 'classnames/bind';
const cx = classnames.bind(styles);

interface MailProps extends UseControllerProps {
  visible?: boolean;
  isSuccessMailAuth: boolean;
  setIsSuccessMailAuth: (isSuccessMailAuth: boolean) => void;
  resetValue?: string | null;
}

const Mail = (props: MailProps) => {
  const { name, setIsSuccessMailAuth, resetValue } = props;
  const {
    formState: { isSubmitted },
    setValue,
  } = useFormContext();

  const { field: mailField } = useController(props);
  const isEmailPattern = mailField.value ? mailField.value.match(PATTERN.EMAIL) : true;
  const {
    inputWrapRef,
    isOpen,
    emailText,
    emailList,
    selected,
    setSelected,
    handleOnKeyDown,
    handleOnClickEmail,
    handleOnChange,
  } = useRecommendEmailList();

  const handleClick = (item: string) => {
    const value = `${emailText.split('@')[0]}${item}`;
    handleOnClickEmail(emailText, item);
    checkEmail(value);
    setValue(name, value);
  };

  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    handleOnKeyDown(e);
    if (!isOpen) return;
    if (e.key === 'Enter') {
      if (selected === -1) return;
      const value = `${emailText.split('@')[0]}${emailList[selected]}`;
      checkEmail(value);
      setValue(name, value);
    }
  };

  const emailEls = emailList.map((item, index) => {
    const text = `${emailText.split('@')[0]}${item}`;
    const remainingText = text.split(emailText);

    return (
      <li
        key={index}
        className={cx('emailItem', { selected: selected === index })}
        onClick={() => handleClick(item)}
        onMouseOver={() => setSelected(index)}
      >
        <em className={cx('em')}>{emailText}</em>
        <span>{remainingText[1]}</span>
      </li>
    );
  });

  const checkEmail = (value: string) => {
    if (value.match(PATTERN.EMAIL) && resetValue !== value) setIsSuccessMailAuth(true);
    else setIsSuccessMailAuth(false);
  };

  return (
    <div className={cx('mailArea')}>
      <div ref={inputWrapRef} className={cx('mailWrap')}>
        <input
          type="text"
          {...mailField}
          className={cx('input', { error: !isEmailPattern })}
          placeholder="이메일을 입력해주세요."
          autoComplete="off"
          onChange={(e) => {
            mailField.onChange(e);
            handleOnChange(e);
            checkEmail(e.target.value);
          }}
          value={mailField.value}
          onKeyDown={(e) => handleKeyDown(e)}
        />
      </div>
      <ul className={cx('emailList', { visible: isOpen })}>{emailEls}</ul>
      {!isEmailPattern && <div className={cx('errorMessage')}>올바른 이메일 형식이 아닙니다.</div>}
    </div>
  );
};

export default Mail;
